import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * The PriiLifecycle native plugin (ios/App/App/PriiLifecyclePlugin.swift): what ended the last app process. On
 * 2026-10-29 the app exited cleanly three times a few ms after entering the background with no reason anywhere;
 * applicationWillTerminate and an atexit hook now leave a backtrace, read here once at launch (lib/appLog).
 */
const PriiLifecycle = registerPlugin('PriiLifecycle');

/** The last recorded exit, or null; the native side clears it on read. Never throws. */
export async function takeLastNativeExit() {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const r = await PriiLifecycle.getLastExit();
    return r?.found ? r : null;
  } catch {
    return null; // an older native build without the plugin
  }
}
